import type { LearnResearchMetadata } from "./researchMetadata.js";

/**
 * Source-bound overview drafts reached from the Home learning index. They are
 * deliberately excluded from the ten-card Learn research catalogue so they do
 * not change its accepted inventory. They contain no response instructions.
 */
export const supplementalDraftMetadata: readonly LearnResearchMetadata[] = [
  {
    slug: "everyday",
    category: "preparedness",
    icon: "home",
    title: "learn.everyday.title",
    detail: "learn.everyday.detail",
    status: "research_only",
    source: "learn.library.source.thailand_dossier",
    researchedOn: "2026-10-01",
    explanation: "learn.detail.everyday.explanation",
    whyItMatters: "learn.detail.everyday.why",
    scope: "learn.detail.everyday.scope",
    gaps: "learn.detail.everyday.gaps",
    sources: [
      {
        label: "Department of Health: chemical leak information",
        url: "https://www.anamai.moph.go.th/th/news-anamai/43638",
      },
      {
        label: "Thai FDA Food Division: label requirements and examples",
        url: "https://food.fda.moph.go.th/for-entrepreneurs/test-labeling-and-examples",
      },
    ],
  },
  {
    slug: "accidents",
    category: "health",
    icon: "alert",
    title: "learn.accidents.title",
    detail: "learn.accidents.detail",
    status: "review_required",
    source: "learn.library.source.thailand_dossier",
    researchedOn: "2026-10-01",
    explanation: "learn.detail.accidents.explanation",
    whyItMatters: "learn.detail.accidents.why",
    scope: "learn.detail.accidents.scope",
    gaps: "learn.detail.accidents.gaps",
    sources: [
      {
        label: "Thai Red Cross: First Aid Training Centre",
        url: "https://redcross.or.th/aboutus/department/firstaid/",
      },
      {
        label: "Thai Red Cross: first-aid manual — choking section",
        url: "https://trcyvolunteer.redcross.or.th/wp-content/uploads/2024/08/%E0%B8%84%E0%B8%B9%E0%B9%88%E0%B8%A1%E0%B8%B7%E0%B8%AD%E0%B8%9B%E0%B8%90%E0%B8%A1%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%AA%E0%B8%B3%E0%B8%AB%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%A2%E0%B8%B2%E0%B8%A7%E0%B8%8A%E0%B8%99.pdf",
      },
    ],
  },
  {
    slug: "practical",
    category: "preparedness",
    icon: "book",
    title: "learn.practical.title",
    detail: "learn.practical.detail",
    status: "draft",
    source: "learn.library.source.local_tools",
    researchedOn: "2026-10-01",
    explanation: "learn.detail.practical.explanation",
    whyItMatters: "learn.detail.practical.why",
    scope: "learn.detail.practical.scope",
    gaps: "learn.detail.practical.gaps",
    sources: [
      { label: "SafeSphere Family Plan (on-device feature)", url: "/family-plan" },
      {
        label: "DDPM public disaster-preparedness handbook",
        url: "https://www.disaster.go.th/upload/download/file_attach/58cb60f5607de.pdf",
      },
    ],
  },
  {
    slug: "disasters",
    category: "hazards",
    icon: "search",
    title: "learn.disasters.title",
    detail: "learn.disasters.detail",
    status: "research_only",
    source: "learn.library.source.thailand_dossier",
    researchedOn: "2026-10-01",
    explanation: "learn.detail.disasters.explanation",
    whyItMatters: "learn.detail.disasters.why",
    scope: "learn.detail.disasters.scope",
    gaps: "learn.detail.disasters.gaps",
    sources: [
      {
        label: "DDPM public disaster-preparedness handbook",
        url: "https://www.disaster.go.th/upload/download/file_attach/58cb60f5607de.pdf",
      },
      { label: "Thai Meteorological Department", url: "https://www.tmd.go.th/" },
    ],
  },
  {
    slug: "outdoors",
    category: "preparedness",
    icon: "shield",
    title: "learn.outdoors.title",
    detail: "learn.outdoors.detail",
    status: "research_only",
    source: "learn.library.source.thailand_dossier",
    researchedOn: "2026-10-01",
    explanation: "learn.detail.outdoors.explanation",
    whyItMatters: "learn.detail.outdoors.why",
    scope: "learn.detail.outdoors.scope",
    gaps: "learn.detail.outdoors.gaps",
    sources: [
      {
        label: "DDPM public disaster-preparedness handbook",
        url: "https://www.disaster.go.th/upload/download/file_attach/58cb60f5607de.pdf",
      },
      { label: "Thai Meteorological Department", url: "https://www.tmd.go.th/" },
    ],
  },
  ...(["forest", "sea", "cold"] as const).map((environment) => ({
    slug: `outdoors-${environment}`,
    category: "preparedness" as const,
    icon: "shield" as const,
    title: `learn.outdoors.${environment}` as const,
    detail: `learn.outdoors.${environment}_detail` as const,
    status: "review_required" as const,
    source: "learn.library.source.thailand_dossier" as const,
    researchedOn: "2026-10-01",
    explanation: `learn.detail.outdoors_${environment}.explanation` as const,
    whyItMatters: `learn.detail.outdoors_${environment}.why` as const,
    scope: `learn.detail.outdoors_${environment}.scope` as const,
    gaps: `learn.detail.outdoors_${environment}.gaps` as const,
    sources: [
      {
        label: "DDPM public disaster-preparedness handbook",
        url: "https://www.disaster.go.th/upload/download/file_attach/58cb60f5607de.pdf",
      },
      { label: "Thai Meteorological Department", url: "https://www.tmd.go.th/" },
    ],
  })),
];
